import { render, staticRenderFns } from "./CardResv.vue?vue&type=template&id=1f5d34ce&scoped=true"
import script from "./CardResv.vue?vue&type=script&lang=js"
export * from "./CardResv.vue?vue&type=script&lang=js"
import style0 from "./CardResv.vue?vue&type=style&index=0&id=1f5d34ce&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5d34ce",
  null
  
)

export default component.exports